import React from 'react';
import {Table} from 'web-components';
import {TableContainer, ColumnWrapper} from '../project_health_styles/ProjectHealthTableSection.styled';
import {ActionsColumn} from './ActionsColumn';
import {getBaseLevelTableHeader} from './ProjectHealthTableHeader';
import {TitleStatusColumn} from './TitleStatusColumn';

export const ProjectHealthTable = ({data, projectHalted}) => {
	return (
		<TableContainer>
			<Table>
				{getBaseLevelTableHeader()}
				<Table.Rows
					data={{
						rows: data,
					}}
				>
					{({rowData, tableColumnsProps}) => {
						const rowDisabled = projectHalted || !rowData.actionCallback;
						return (
							<Table.Row
								hoverStyle={{
									color: 'blue',
								}}
								{...tableColumnsProps}
							>
								<Table.Column>
									<TitleStatusColumn
										title={rowData.title}
										warningVariant={rowData.warningVariant}
										disabled={rowDisabled}
									/>
								</Table.Column>
								<Table.Column>
									<ColumnWrapper disabled={rowDisabled}>{rowData.info}</ColumnWrapper>
								</Table.Column>
								<Table.Column>
									<ColumnWrapper>
										{rowData.actionCallback ? (
											<ActionsColumn actionCallback={rowData.actionCallback}></ActionsColumn>
										) : null}
									</ColumnWrapper>
								</Table.Column>
							</Table.Row>
						);
					}}
				</Table.Rows>
			</Table>
		</TableContainer>
	);
};
